export default __webpack_public_path__ + "static/media/submit.3767cd16.gif";